export interface PhotoFocalPoint {
  x: number;
  y: number;
}

export const DEFAULT_PHOTO_FOCAL_POINT: PhotoFocalPoint = { x: 50, y: 50 };

export function normalizePhotoFocalPoint(
  x?: number | null,
  y?: number | null,
): PhotoFocalPoint {
  const safeX = typeof x === 'number' && Number.isFinite(x) ? x : DEFAULT_PHOTO_FOCAL_POINT.x;
  const safeY = typeof y === 'number' && Number.isFinite(y) ? y : DEFAULT_PHOTO_FOCAL_POINT.y;
  return {
    x: clampFocal(safeX),
    y: clampFocal(safeY),
  };
}

export function clampFocal(value: number): number {
  return Math.max(0, Math.min(100, value));
}

export function photoObjectPosition(focal: PhotoFocalPoint): string {
  return `${focal.x}% ${focal.y}%`;
}

export function panFocalPoint(
  focal: PhotoFocalPoint,
  deltaX: number,
  deltaY: number,
  frameWidth: number,
  frameHeight: number,
): PhotoFocalPoint {
  const sensitivityX = frameWidth > 0 ? (100 / frameWidth) * 0.85 : 0;
  const sensitivityY = frameHeight > 0 ? (100 / frameHeight) * 0.85 : 0;
  return {
    x: clampFocal(focal.x - deltaX * sensitivityX),
    y: clampFocal(focal.y - deltaY * sensitivityY),
  };
}
